/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';
import common from '../_common/common_sales';

const datasetParams = {
  mainFile: 'Sales/Outputs/s_data/Sales_s_data.csv',
  runDetailsFile: 'Sales/Outputs/s_data/Sales_s_data_runDetails.csv',
  tableName: 'Sales_s_allYears',
  mainDateField: 'Date',
  headersRemaps: {
    VALID_PARK_ST: 'State',
    NumberItemsSold: 'SalesUnits',
    NumberItemsSold_AllParks: 'SalesUnits_AllParks',
    Revenue: 'SalesRevenues',
    Raw_Revenue: 'SalesRevenues_Raw',
  },
  valuesRemaps: {
    Channel: {
      'Internet - Consumer Direct': 'Internet',
    },
    ProductType: {
      'MDT/MPT': 'MDT',
    },
    Flag_HOS: {
      0: '0',
    },
    Flag_Group: {
      0: '0',
    },
  },
  calculatedMetrics: common.sales_calculatedMetrics,
  metrics: common.sales_metrics,
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
    ProductCategory: ['SDT', 'MDT'].includes(row.ProductType) ? 'Discrete' : ['FC', 'Fun Card', 'Pass'].includes(row.ProductType) ? 'Pass' : 'Free',
  }),
  filterDimensions: {
    ...common.sales_filterDimensions,
    Channel: {
      order: 'desc',
      customOrder: ['Internet', 'In-Park', 'Contact Center', 'Business Partner'],
    },
    BP_Category: {
      order: 'desc',
      customOrder: ['Domestic OTA', 'Domestic In-Market', 'Domestic Military', 'International', 'Groups', 'Others'],
    },
    State: {
      order: 'desc',
      customOrder: ['FL', 'CA', 'TX', 'VA', 'PA'],
    },
    PaymentType: {
      order: 'desc',
    },
    Flag_HOS: {
      order: 'asc',
    },
    Flag_Group: {
      order: 'asc',
    },
  },
};

export default datasetParams;
